import * as React from "react";

import { ParcelList } from "../parcel-list/parcel-list";
import { observer } from "mobx-react";
import { Parcel } from "../../../model/parcel";
import { ParcelDetail } from "../../../model/parcel-detail";
import { ParcelFilter } from "../../../model/parcel-filter";
import { SearchListModel } from "../../../../common/component/list/search-list/search-list-model";
import { context } from "../../../../context/context";
import { ParcelStatusType, ReviewReadyToShipActionType } from "../../../constants/constants";
import { ParcelDataExporter } from "../parcel-list/parcel-data-exporter";
import { Permission } from "../../../../context/permission";
import { SingleActionPicker } from "../../../../common/component/action/action-select/single-action-picker";
import { IWithRouterProps, withRouter } from "../../../../common/component/hoc/withRouter";
import { Fragment } from "react";
import { ParcelStockoutDialog } from "../parcel-stockout-dialog/parcel-stockout-dialog";
import { IActionCommand } from "../../../../common/component/action/action-select/bulky-action-picker";
import { ReviewReadyToShipHeader } from "./review-ready-to-ship-header";

const parcelManagementModel = new SearchListModel<Parcel, ParcelDetail, ParcelFilter>();

interface IReviewReadyToShipComponentProps {
    isParcelMarkAsStockoutDialogOpen: boolean;
    markAsStockoutParcels: Parcel[];

    singleActionPickerAnchorElement: HTMLElement | null;
    singleActionPickerParcelItem: Parcel | null;
}

@observer
class ReviewReadyToShipComponent extends ParcelList<IReviewReadyToShipComponentProps> {
    public state: IReviewReadyToShipComponentProps = {
        isParcelMarkAsStockoutDialogOpen: false,
        markAsStockoutParcels: [],

        singleActionPickerAnchorElement: null,
        singleActionPickerParcelItem: null,
    };

    constructor(props: IWithRouterProps) {
        super(props, parcelManagementModel, new ParcelDataExporter("Ship parcel", true, true));
    }

    protected get parcelStatusFilter(): ParcelStatusType {
        if (context.hasPermission(Permission.FeatureReadyToShip)) {
            return "ReadyToShip";
        }
        return "Labeled";
    }

    protected renderActions() {
        return <Fragment>
            <ReviewReadyToShipHeader actionsList={this.actionsList}
                                     reloadParcelsList={() => this.reloadParcelList()} />
            {this.state.singleActionPickerAnchorElement &&
                <SingleActionPicker anchorElement={this.state.singleActionPickerAnchorElement}
                                    item={this.state.singleActionPickerParcelItem}
                                    list={this.singleActionsList}
                                    onActionComplete={() => this.reloadParcelList()}
                                    onPickerClose={() => this.closeSingleActionPickerMenu()} />}
            {this.state.isParcelMarkAsStockoutDialogOpen &&
                <ParcelStockoutDialog parcelsList={this.state.markAsStockoutParcels}
                                      getParcelItemByScan={parcelId => this.getParcelItemByScan(parcelId)}
                                      onParcelChanged={() => this.reloadParcelList()}
                                      onCancel={() => this.closeParcelStockoutDialog()} />}
        </Fragment>;
    }

    protected get actionsList(): Array<IActionCommand<Parcel, ReviewReadyToShipActionType>> {
        return [{
                execute: parcelList => this.openParcelStockoutForSelection(parcelList),
                hideActionProgressLoader: true,
                executeCustomScanMode: () => this.openParcelStockoutForScan(),
                label: "parcelReviewReadyToShip.action.parcelMarkAsStockout.title",
                loadExecuteParam: (isScan, param) => this.loadExecuteActionParam(isScan, param),
                value: "parcelMarkAsStockout",
                description: "parcelReviewReadyToShip.action.parcelMarkAsStockout.description",
                hideExecutionConfirmation: true,
        }];
    }

    protected openSingleActionPickerMenu(anchor: any, item: Parcel) {
        this.setState({
            singleActionPickerAnchorElement: anchor,
            singleActionPickerParcelItem: item,
        });
    }

    private closeSingleActionPickerMenu() {
        this.setState({
            singleActionPickerParcelItem: null,
            singleActionPickerAnchorElement: null,
        });
    }

    private openParcelStockoutForSelection(identifierList: Parcel[]) {
        this.setState({
            isParcelMarkAsStockoutDialogOpen: true,
            markAsStockoutParcels: identifierList,
        });
    }

    private openParcelStockoutForScan() {
        this.setState({
            isParcelMarkAsStockoutDialogOpen: true,
            markAsStockoutParcels: [],
        });
    }

    private closeParcelStockoutDialog() {
        this.setState({
            isParcelMarkAsStockoutDialogOpen: false,
            markAsStockoutParcels: [],
        });
    }

    protected getSuccessMessage() {
        return "";
    }

    protected get hiddenSortFields() {
        return ["shipmentDate"];
    }

    protected get isSelectionEnabled() {
        return context.hasPermission(Permission.FrontWrite);
    }

    protected get isParcelTrackerDisplayed() {
        return true;
    }

    protected get isPalletCodeDisplayed() {
        return true;
    }

    protected get allowOrderPendingCancellationFiltering() {
        return true;
    }

    protected get allowOrderCancellationStatusFiltering() {
        return false;
    }
}

export const ReviewReadyToShip = withRouter(ReviewReadyToShipComponent);
